export const FADE = 'fade';
export const SCALE = 'scale';